import { Lud } from "../model/lud.model";
import { SegmentoTela } from "../model/segmento.model";

/**
 * Esta classe implementa o mapeamento do conteúdo do ato para a localização de sinônimos e palavras
 * reservadas para a confecção de LUDs.
 * 
 * Para melhor performance, os conteúdos dos segmentos são agrupados em uma grande string textoAto.
 * 
 * No retorno, os sinônimos e as palavras-chave são indexadas em relação ao textoAto, mas precisam
 * ser localizados em seus respectivos segmentos.
 * 
 * Detalhe: não há confecção de LUDs nas ementas nem em segmentos do tipo anexo.
 */
export class MapaTextoAto {
    public textoAto: string;
    private posicoes: PosicaoRelativa[];

    constructor(segmentos: SegmentoTela[]) {

        // construção do textoAto
        let texto = '';
        let inicio = 0;
        this.posicoes = [];
        for (let idx = 0; idx < segmentos.length; idx++) {
            const segmento = segmentos[idx];
            if (segmento.editor && segmento.idTipoSegmento != 1 && segmento.idTipoSegmento != 16) {
                texto += segmento.editor.getText(0);

                // armazenamento do posicionamento do conteúdo do segmento no textoAto
                this.posicoes.push({ idx: idx, inicio: inicio, fim: texto.length });
                inicio = texto.length;
            }
        }
        this.textoAto = texto;
    }

    /**
     * Obtém um objeto Lud com a posição ajustada dentro do texto do ato.
     * Define idx do segmento, texto e posição relativa dentro do segmento.
     * @param inicio A posição inicial do trecho desejado.
     * @param fim A posição final do trecho desejado.
     * @returns Um objeto Lud com o texto, índice, início e fim ajustados.
     */
    public obterLudComPosicaoAjustada(inicio: number, fim: number): Lud {
        const lud = new Lud();

        const posicaoRelativa = this.localizarPosicaoRelativa(inicio);
        if (posicaoRelativa != null) {
            lud.texto = this.textoAto.substring(inicio, fim);
            lud.idx = posicaoRelativa.idx;
            lud.inicio = inicio - posicaoRelativa.inicio;
            lud.fim = fim - posicaoRelativa.inicio;
        }
        return lud;
    }

    /**
     * Localiza a posição relativa (idx do segmento, inicio) com base em uma posição específica.
     * @param posicao A posição específica.
     * @returns A posição relativa encontrada ou null se não for encontrada.
     */
    private localizarPosicaoRelativa(posicao: number): PosicaoRelativa | null {
        const found = this.posicoes.filter(r => posicao >= r.inicio && posicao < r.fim);
        if (found.length == 1) {
            return found[0];
        }
        return null;
    }
}

/**
 * Armazena a posição relativa do conteúdo de um segmento no textoAto.
 */
class PosicaoRelativa {
    idx: number;    /* índice do segmento em segmentos[] */
    inicio: number; /* posição do primeiro caracter do segmento em this.textoAto */
    fim: number;    /* posição após último caracter do segmento em this.textoAto */
}
